
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/board",
      function () {
        return require("private-next-pages/board/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/board"])
      });
    }
  